export const widgets = {
    today: "1401/09/12",
    dayName: "شنبه",
    salesInfo: {
        dailyInvoices: 197,
        dailySales: 50000000,
        monthlyInvoices: 12000,
        monthlySales: 8930000000,
    },
    cartInfo: null,
    userInfo: {
        totalActiveUsers: 893,
        periodIDCustomers: 893,
        currentCartUser: 0,
    },
    lastOrderInfo: {
        orderID: 100,
        time: "1401/09/12 20:27:47",
        price: "3400000",
        customerName: "تست",
    },
    salesCharts: {
        currentMonth: [
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/01",
                orderCount: 1757,
                sumPrice: "10000",
                sumPoint: 36013,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/02",
                orderCount: 1570,
                sumPrice: "10000",
                sumPoint: 37654,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/03",
                orderCount: 1845,
                sumPrice: "10000",
                sumPoint: 78411,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/04",
                orderCount: 2199,
                sumPrice: "10000",
                sumPoint: 80153,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/05",
                orderCount: 1592,
                sumPrice: "10000",
                sumPoint: 80744,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/06",
                orderCount: 634,
                sumPrice: "10000",
                sumPoint: 70432,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/07",
                orderCount: 889,
                sumPrice: "10000",
                sumPoint: 28857,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/08",
                orderCount: 570,
                sumPrice: "10000",
                sumPoint: 83891,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/09",
                orderCount: 385,
                sumPrice: "10000",
                sumPoint: 8266,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/10",
                orderCount: 293,
                sumPrice: "10000",
                sumPoint: 9318,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/11",
                orderCount: 785,
                sumPrice: "10000",
                sumPoint: 55041,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/12",
                orderCount: 197,
                sumPrice: "10000",
                sumPoint: 3272,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/13",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/14",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/15",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/16",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/17",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/18",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/19",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/20",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/21",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/22",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/23",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/24",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/25",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/26",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/27",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/28",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/29",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/09/30",
                orderCount: 0,
                sumPrice: "0",
                sumPoint: 16180,
            },
        ],
        lastMonth: [
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/01",
                orderCount: 368,
                sumPrice: "679115781",
                sumPoint: 781,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/02",
                orderCount: 134,
                sumPrice: "289647666",
                sumPoint: 666,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/03",
                orderCount: 288,
                sumPrice: "511005356",
                sumPoint: 356,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/04",
                orderCount: 100,
                sumPrice: "329663642",
                sumPoint: 642,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/05",
                orderCount: 83,
                sumPrice: "248737531",
                sumPoint: 531,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/06",
                orderCount: 366,
                sumPrice: "771237428",
                sumPoint: 428,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/07",
                orderCount: 222,
                sumPrice: "424800218",
                sumPoint: 218,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/08",
                orderCount: 313,
                sumPrice: "518295599",
                sumPoint: 599,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/09",
                orderCount: 173,
                sumPrice: "454160345",
                sumPoint: 345,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/10",
                orderCount: 201,
                sumPrice: "417038343",
                sumPoint: 343,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/11",
                orderCount: 239,
                sumPrice: "543572759",
                sumPoint: 759,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/12",
                orderCount: 100,
                sumPrice: "200000000",
                sumPoint: 999,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/13",
                orderCount: 336,
                sumPrice: "823024130",
                sumPoint: 130,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/14",
                orderCount: 193,
                sumPrice: "387007457",
                sumPoint: 457,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/15",
                orderCount: 200,
                sumPrice: "346819329",
                sumPoint: 329,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/16",
                orderCount: 166,
                sumPrice: "409989215",
                sumPoint: 215,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/17",
                orderCount: 540,
                sumPrice: "1254371250",
                sumPoint: 1250,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/18",
                orderCount: 219,
                sumPrice: "392118134",
                sumPoint: 134,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/19",
                orderCount: 569,
                sumPrice: "1186785934",
                sumPoint: 5934,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/20",
                orderCount: 845,
                sumPrice: "1655167105",
                sumPoint: 7105,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/21",
                orderCount: 500,
                sumPrice: "962236773",
                sumPoint: 773,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/22",
                orderCount: 312,
                sumPrice: "570747927",
                sumPoint: 927,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/23",
                orderCount: 383,
                sumPrice: "801091520",
                sumPoint: 520,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/24",
                orderCount: 215,
                sumPrice: "421093617",
                sumPoint: 617,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/25",
                orderCount: 125,
                sumPrice: "264885620",
                sumPoint: 620,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/26",
                orderCount: 118,
                sumPrice: "217399669",
                sumPoint: 669,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/27",
                orderCount: 366,
                sumPrice: "629160182",
                sumPoint: 182,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/28",
                orderCount: 346,
                sumPrice: "654606375",
                sumPoint: 375,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/29",
                orderCount: 584,
                sumPrice: "1288299916",
                sumPoint: 9916,
            },
            {
                orderDateDay: "0001-01-01T00:00:00",
                orderDate: "1401/08/30",
                orderCount: 720,
                sumPrice: "1537735210",
                sumPoint: 5210,
            },
        ],
        lastMonthTotalPrice: "1000000000",
    },
    brandSaleReportModel: {
        todayReport: [],
        monthlyReport: [],
    },
    ordersReportInApp: {
        userCount: 0,
        orderCount: 0,
        sumPrices: 0,
    },
    topMarketersPointsLayer1: null,
}

export const warehouseData = {
    productLastCharged: {
        productName: "خمیر دندان ژله ای",
        chargeCount: 10,
        lastCount: 0,
    },
    productsAvaiablePrice: {
        totalProductCount: 120000,
        totalProductPrice: "1000000000",
        totalProductPoints: null,
    },
    salesCharts: {
        currentMonth: null,
        lastMonth: null,
        lastMonthTotalPrice: null,
    },
    brandsRequestsForCharge: [],
}

export const bankData = {
    UsersBooked: {
        UsersCount: 1,
        TotalProductsCount: 2,
        TotalProductsPrice: 1000000,
    },
    UsersNotBooked: {
        UsersCount: 500,
        TotalProductsCount: 1000,
        TotalProductsPrice: 1200000000,
    },
}
